import { compact, isNil } from "lodash";
import ReactMarkdown from "react-markdown";
import { useLocation } from "react-router-dom";
import { AskAiChatMessageFragmentFragment } from "types/graphql-schema";
import { TFLocationState } from "types/topicflow";

import Avatar from "@components/avatar/avatar";
import AppLink from "@components/link/link";
import { toWithBackground } from "@helpers/helpers";

const AskAIEmbedOverviewDirectReports = ({
  outputItem,
}: {
  outputItem: NonNullable<
    NonNullable<AskAiChatMessageFragmentFragment["outputItems"]>[number]
  >;
}) => {
  const location = useLocation<TFLocationState>();
  if (!outputItem.overviewDirectReports) return null;

  const directReports = compact(
    outputItem.overviewDirectReports.directReports || [],
  ).filter((report) => !isNil(report.user));

  if (directReports.length === 0) return null;

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="flex flex-col gap-6">
        {directReports.map((report) => (
          <div key={report.user.id}>
            <div className="mb-2 flex gap-2 items-center">
              <AppLink
                to={toWithBackground({
                  pathname: `/profile/${report.user.id}`,
                  location: location,
                })}
                className="tf-header-base-dark inline-flex items-center gap-2 hover:text-black"
              >
                <Avatar user={report.user} size="5" />
                <span>{report.user.name}</span>
              </AppLink>
            </div>
            <div className="prose prose-sm max-w-none">
              <ReactMarkdown>
                {report.summary ? report.summary : "No summary provided."}
              </ReactMarkdown>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AskAIEmbedOverviewDirectReports;
